import React from "react";
import { PublicRoutesProps } from "./PublicRoutesProps";
import { useAuth } from "../../../hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";

const PublicRoutes: React.FC<PublicRoutesProps> = ({ element }) => {
  const { isAuthenticated, isAuthLoading } = useAuth();
  const location = useLocation();

  // Don't render the public page or redirect until auth is restored. This
  // prevents a reload (e.g. from the Bhashini widget) from flashing the login
  // page and then bouncing an authenticated user to /dashboard.
  if (isAuthLoading) {
    return null;
  }

  return (
    <div>
      {!isAuthenticated ? (
        element
      ) : (
        <Navigate to="/dashboard" state={{ from: location }} replace />
      )}
    </div>
  );
};

export default PublicRoutes;
